import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'tidy-ai-loader',
  templateUrl: './ai-loader.component.html',
  styleUrls: ['./ai-loader.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiLoaderComponent implements OnInit {
  @Input() class = 'agent-icon';
  @Input() isStatic = false;
  @Input() colored = false;
  animationDelay = '0s';
  particleDelay = '0s';
  coreDelay = '0s';

  ngOnInit() {
    const now = Date.now();
    const rotationDuration = 12000;
    const particleDuration = 6000;
    const coreDuration = 3000;
    this.animationDelay = `-${now % rotationDuration}ms`;
    this.particleDelay = `-${now % particleDuration}ms`;
    this.coreDelay = `-${now % coreDuration}ms`;
  }
}
